<app-loading-overlay [isLoading]="deleting" class="dialog-fill">
  <bv-dialog-title>{{ "DELETE_ACCOUNT" | translate }}</bv-dialog-title>
  <bv-dialog-body class="min-300">
    <p class="delete-account__warning">{{ "DELETE_ACCOUNT_WARNING" | translate }}</p>

    <ul class="delete-account__consequences">
      <li>{{ "DELETE_ACCOUNT_CONSEQUENCE_PROFILE" | translate }}</li>
      @if (ownedClubsCount) {
        <li>{{ "DELETE_ACCOUNT_CONSEQUENCE_CLUBS" | translate }}</li>
      }
      @if (hasSubscription) {
        <li>{{ "DELETE_ACCOUNT_CONSEQUENCE_SUBSCRIPTION" | translate }}</li>
      }
    </ul>

    <p class="delete-account__irreversible">{{ "DELETE_ACCOUNT_IRREVERSIBLE" | translate }}</p>

    <bv-form-field label="{{ 'TYPE_TO_CONFIRM' | translate:{ word: confirmWord } }}">
      <input
        id="input_delete_account_confirm"
        bv-input
        type="text"
        name="confirmDelete"
        autocomplete="off"
        [(ngModel)]="confirmInput"
      />
    </bv-form-field>
  </bv-dialog-body>
  <bv-dialog-footer>
    <app-close-dialog-button></app-close-dialog-button>
    <button
      id="btn_delete_account_confirm"
      bv-button
      variant="danger"
      (click)="confirmDelete()"
      [disabled]="!canDelete"
    >
      {{ "DELETE_ACCOUNT" | translate }}
    </button>
  </bv-dialog-footer>
</app-loading-overlay>
